module.exports = __webpack_public_path__ + "img/sport_xtreme.5570d3c9.svg";